module.exports = __webpack_public_path__ + "static/img/zhongwaimingjiu.3f121ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type/daohang/zhongwaimingjiu.png
// module id = piQH
// module chunks = 12